module.exports = __webpack_public_path__ + "static/media/remily-logo-circle.da11f75a.svg";